import { Component, OnInit, Input, ViewChild, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CopyToClipboardComponent implements OnInit {

  @Input() value: string;
  @Input() idleEnable: boolean = true;
  @Output() onCopy = new EventEmitter();
  firstClick:boolean=true;
  idle:boolean=false;

  
  @ViewChild('popperTarget') popperTarget: any;
  constructor() {}

  ngOnInit() {
    if(this.idleEnable)
      setTimeout(() => this.idle= this.firstClick, 3000);
  }
  copy(){
    this.idle=false;
    if(this.firstClick){
      this.firstClick=false;
      this.onCopy.emit();
    }
  }
}
